import React, { useState } from "react";

interface URLInputStepProps {
  onSubmit: (url: string) => void;
  isLoading: boolean;
}

const URLInputStep: React.FC<URLInputStepProps> = ({ onSubmit, isLoading }) => {
  const [url, setUrl] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (url.trim()) {
      onSubmit(url.trim());
    }
  };

  return (
    <div style={{ textAlign: "center", maxWidth: "500px", width: "100%" }}>
      <h2 style={{ fontSize: "1.8rem", marginBottom: "0.5rem" }}>
        Let's build your newsletter
      </h2>
      <p style={{ color: "#666", marginBottom: "2rem" }}>
        Enter your website and we'll design a newsletter strategy in minutes.
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="yourcompany.com"
          autoFocus
          style={{
            width: "100%",
            padding: "14px 18px",
            fontSize: "1.1rem",
            border: "2px solid #e0e0e0",
            borderRadius: "12px",
            outline: "none",
            marginBottom: "1rem",
            boxSizing: "border-box",
          }}
        />
        <button
          type="submit"
          disabled={!url.trim() || isLoading}
          className="secondary-button"
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "0.95rem",
            whiteSpace: "nowrap", maxWidth: "none",
            opacity: !url.trim() || isLoading ? 0.5 : 1,
          }}
        >
          {isLoading ? "Analyzing your site..." : "Analyze My Site →"}
        </button>
      </form>
    </div>
  );
};

export default URLInputStep;
